import React from 'react';
import { Route, Routes } from 'react-router';

import { RequireAuth } from '@/core/auth/RequireAuth';
import { DashboardPage } from '@/pages/DashboardPage';
import { LoginPage } from '@/pages/LoginPage';

export const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<RequireAuth />}>
      <Route path="/" element={<DashboardPage />} />
    </Route>
  </Routes>
);
